module.exports = __webpack_public_path__ + "img/case_top_001.edde69d1.png";